const initialState = {
  results: [],
  activities: [],
  features: [],
  types: [],
  region: null,
  all: {},
  fetching: false,
  fetchingMore: false,
  fetched: false,
  error: null,
  totalCount: null,
  mobile_filter_panel_open: null,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'RESET_LISTINGS':
      return initialState

    case 'FETCH_LISTINGS_PENDING':
      return {
        ...state,
        fetching: true,
      }

    case 'FETCH_LISTINGS_REJECTED':
      return {
        ...state,
        fetching: true,
        error: action.payload,
      }

    case 'FETCH_LISTINGS_FULFILLED':
      return {
        ...state,
        fetching: false,
        fetched: true,
        ...action.payload.data,
        date_from: action.payload.data.qty,
        date_to: action.payload.data.date_to,
      }

    case 'LISTINGS_FETCH_MORE_PENDING':
      return {
        ...state,
        fetchingMore: true,
      }

    case 'LISTINGS_FETCH_MORE_REJECTED':
      return {
        ...state,
        fetchingMore: false,
      }

    case 'LISTINGS_FETCH_MORE_FULFILLED':
      return {
        ...state,
        fetchingMore: false,
        ...action.payload.data,
        results: state.results.concat(action.payload.data.results),
        date_from: action.payload.data.qty,
        date_to: action.payload.data.date_to,
      }

    default:
      return state
  }
}
